import { render, staticRenderFns } from "./CreateResource.vue?vue&type=template&id=eb3f6d1a&"
import script from "./CreateResource.vue?vue&type=script&lang=ts&"
export * from "./CreateResource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports